module.exports = __webpack_public_path__ + "static/media/noun_filter_737854.36cea482.svg";